module.exports = __webpack_public_path__ + "static/media/gaming6.eed75d37.webp";